import { addAgenda, getMeetingPoints } from "../../../api/meeting/meeting";
import { AddMeetingPoint } from ".";
import { AddMinute } from ".";
import { Button } from "../../Button";
import { ConfirmationModal } from "../../ConfirmationModal";
import { MeetingPoint } from ".";
import { PropTypes } from "prop-types";
import { QueryLoader } from "../../Loader";
import { StyledDirectionTableContainer, StyledDirectionTableHeader } from "../../../styles/StyledDecision/StyledContent";
import { StyledModal, StyledPointsModal } from "../../../styles/StyledModal";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useState } from "react";
import AddIcon from "../../../assets/img/icons/add.svg";
import Modal from "react-modal";
import ModalHeader from "../../ModalHeader/ModalHeader";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function MeetingPoints({ id }) {
	const axiosHandler = useAxiosPrivate();
	const [wasEdited, setWasEdited] = useState(false);

	const { isLoading, isError, error, data, refetch } = useQuery(["meetingPointsTab", id, wasEdited], () =>
		getMeetingPoints(axiosHandler.axiosPrivate, id)
	);

	const [resultMeetingPoints, setResultMeetingPoints] = useState([]);
	const [editedMeetingPoints, setEditedMeetingPoints] = useState([]);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [deletedId, setDeletedId] = useState(null);
	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [editedId, setEditedId] = useState(null);
	const [isMinutesModalOpen, setIsMinutesModalOpen] = useState(false);
	const [minuteId, setMinuteId] = useState(null);

	useEffect(() => {
		if (isError) console.log(error);

		if (!isLoading) setResultMeetingPoints([...data]);
		if (!isLoading) setEditedMeetingPoints([...data]);
	}, [isLoading, data]);

	const handleDelete = async () => {
		const res = editedMeetingPoints.filter((e, i) => i !== parseInt(deletedId));
		updateMeetingPoints(res);
	};

	const updateMeetingPoints = async (dirs = editedMeetingPoints, minutesText) => {
		setIsEditModalOpen(false);
		setIsMinutesModalOpen(false);
		const res = [];

		dirs.map((e, i) => {
			const tempObj = {};

			tempObj.title = e.title;
			tempObj.details = e.details;
			tempObj.minutes = e?.minutes;

			if (minutesText && i === parseInt(minuteId)) tempObj.minutes = minutesText;

			if (e?.decision?.id) {
				tempObj.decision = e?.decision?.id;
			} else if (e?.decision) {
				tempObj.decision = parseInt(e?.decision);
			}

			res.push(tempObj);
		});

		await addAgenda(axiosHandler.axiosPrivate, id, res, () => setWasEdited(!wasEdited));
		await setTimeout(() => refetch(), 1000);
	};

	return (
		<>
			{isLoading ? (
				<QueryLoader />
			) : (
				<>
					<StyledDirectionTableHeader sizes={[2.8, 23.5, 36, 13.5, 7, 17.2]}>
						<span>Nr</span>
						<span>Title</span>
						<span>Detail</span>
						<span>Decision</span>
						<span>Action</span>
						<span>Minutes</span>
					</StyledDirectionTableHeader>
					<StyledDirectionTableContainer>
						{data.length > 0 ? (
							data.map((e, i) => (
								<MeetingPoint
									order={i + 1}
									setEditedId={setEditedId}
									key={i}
									id={"" + i}
									data={e}
									openModal={() => setModalIsOpen(true)}
									openEditModal={() => setIsEditModalOpen(true)}
									setDeletedId={setDeletedId}
									openMinuteModal={() => setIsMinutesModalOpen(true)}
									setMinuteId={setMinuteId}
								/>
							))
						) : (
							<h6>No meeting points added</h6>
						)}
						<Button icon={AddIcon} onClick={() => setIsEditModalOpen(true)}>
							Add meeting point
						</Button>
					</StyledDirectionTableContainer>
				</>
			)}

			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => {
					setDeletedId(null);
					setModalIsOpen(false);
				}}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal
					handleDelete={handleDelete}
					deletedId={deletedId}
					closeModal={() => {
						setDeletedId(null);
						setModalIsOpen(false);
					}}
				/>
			</Modal>
			<Modal
				isOpen={isEditModalOpen}
				onRequestClose={() => {
					setIsEditModalOpen(false);
					setEditedId(null);
				}}
				style={StyledPointsModal}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setIsEditModalOpen(false);
						setEditedId(null);
					}}
				>
					Add Meeting Point
				</ModalHeader>
				{!isLoading && !isError && (
					<AddMeetingPoint
						meetingPointsData={resultMeetingPoints}
						editedId={editedId}
						editedMeetingPoints={editedMeetingPoints}
						setEditedMeetingPoints={setEditedMeetingPoints}
						updateMeetingPoints={updateMeetingPoints}
						closeModal={() => {
							setIsEditModalOpen(false);
							setEditedId(null);
						}}
					/>
				)}
			</Modal>
			<Modal
				isOpen={isMinutesModalOpen}
				onRequestClose={() => {
					setIsMinutesModalOpen(false);
					setMinuteId(null);
				}}
				style={StyledPointsModal}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setIsMinutesModalOpen(false);
						setMinuteId(null);
					}}
				>
					Add Minute
				</ModalHeader>
				{!isLoading && !isError && (
					<AddMinute
						id={minuteId}
						meetingPoints={data}
						closeModal={() => setIsMinutesModalOpen(false)}
						handleUpdate={(minuteText) => updateMeetingPoints(editedMeetingPoints, minuteText)}
					/>
				)}
			</Modal>
		</>
	);
}

MeetingPoints.propTypes = {
	id: PropTypes.string,
};
